import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { TextField } from '@material-ui/core';

interface BillingFieldProps {
    parentClasses: ClassNameMap,
    title: string,
    description: string,
    disabled: boolean,
    value: string | null,
    setValue: any
}

const BillingField: React.FC<BillingFieldProps> = ({
    parentClasses,
    title,
    description,
    disabled,
    value,
    setValue
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
      };
    return (
        <div>  
            <div className={parentClasses.formControlLabel}>
                {title.toUpperCase()}
            </div>
            <TextField 
                InputProps={{ 
                    classes: { root: parentClasses.textFieldInput }
                }} 
                variant='outlined'
                disabled={disabled}
                type="number"
                value={value || ''}
                onChange={handleChange}
                />
            <div className={parentClasses.formControlLabelSub}>
                {description}
            </div>
        </div>
    );
}

export default BillingField;